import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import { dartshubBaseUrl } from '@/config/dartshubBaseUrl';

// Client dédié (pas @/axios/dartsHubApi) : /seasons est public et ce store est importé
// par config.ts, donc il ne doit dépendre d'aucun module qui remonte vers config.ts.
const seasonsApi = axios.create({ baseURL: dartshubBaseUrl, timeout: 15000 });

interface SeasonDto {
  id: number;
  label: string;
  start_date: string;
  end_date: string;
  is_current: boolean;
}

function fallbackCurrentSeason(): string {
  // Repli local le temps du premier chargement depuis /seasons (source de vérité : Dartshub backend)
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  return month >= 7 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
}

export const useSeasonStore = defineStore('season', () => {
  const currentSeason = ref<string>(fallbackCurrentSeason());
  const availableSeasons = ref<string[]>([]);
  const loaded = ref(false);

  const load = async (): Promise<void> => {
    if (loaded.value) return;
    try {
      const { data } = await seasonsApi.get<SeasonDto[]>('/seasons');
      availableSeasons.value = data.map((s) => s.label);
      currentSeason.value = data.find((s) => s.is_current)?.label ?? currentSeason.value;
      loaded.value = true;
    } catch {
      // repli silencieux : on garde la valeur calculée localement
    }
  };

  return { currentSeason, availableSeasons, loaded, load };
});
